import ProducerEdit from './ProducerEdit';

export default ProducerEdit;
